import React, { useState, useRef } from 'react';
import { loginUrl2, loginUrlSuppliers } from '../../../utils/staticPageUrls';
import { Layout, Collapse, Button, Select, Table, Tooltip, Row } from 'antd';
import { ReactComponent as Minus } from '../../../assets/icons/minus.svg';
import { ReactComponent as Plus } from '../../../assets/icons/plus.svg';
import { ReactComponent as LandingAntliesIcon } from '../../../assets/icons/landingAntlies.svg';
import { ReactComponent as FirstIcon } from '../../../assets/icons/firstTitleIcon.svg';
import { ReactComponent as SecondIcon } from '../../../assets/icons/secondTitleIcon.svg';
import Guide from '../../../assets/documents/ΦΕΚ_Β_6969_Αντλία Θερμότητας _Θερμοσίφωνα.pdf';
import Guide1 from '../../../assets/documents/ΦΕΚ_Β_362.pdf';
import Guide2 from '../../../assets/documents/2η Τροποποίηση Οδηγού.pdf';
import CommunicationGuide from '../../../assets/documents/Οδηγίες επικοινωνίας_Αλλάζω σύστημα θέρμανσης.pdf';
import FAQ from '../../../assets/documents/Συχνές Ερωτήσεις _v01.pdf';
import DeMinimins from '../../../assets/documents/ΠΡΟΤΥΠΟ ΥΔ DE MINIMIS 2023.docx';
import DeMiniminsGuide from '../../../assets/documents/ΟΔΗΓΟΣ ΣΥΜΠΛΗΡΩΣΗ_ΠΡΟΤΥΠΟ ΥΔ DE MINIMIS.pdf';
import GoodWork from '../../../assets/documents/Βεβαίωση Εγκατάστασης.docx';
import RespDeclarOwner from '../../../assets/documents/Υπόδειγμα_Υπεύθυνης_Δήλωσης_Συναίνεσης_Ιδιοκτήτη.docx';
import UserManualSupplier from '../../../assets/documents/User Manual Προμηθευτών.pdf';
import UserManualBeneficiary from '../../../assets/documents/User Manual - Ωφελούμενων.pdf';
import UserManualReserveRedeem from '../../../assets/documents/User Manual - Δέσμευση και Εξαργύρωση voucher.pdf';
import FirstAdmissionDecision from '../../../assets/documents/1η Απόφαση Υπαγωγής.pdf';
import FirstProvisionaTableRejected from '../../../assets/documents/1ος Προσωρινός Πίνακας_Προς Απόρριψη.pdf';
import DecisionApprovalTables from '../../../assets/documents/Απόφαση Έγκρισης Πινάκων.pdf';
import VoucherUsageFlow from '../../../assets/documents/Διαδικασία και Ροή Χρήσης Επιταγών.pdf';
import GeographicalDistributionVoucherStatus from '../../../assets/documents/Γεωγραφική Κατανομή Προμηθευτών & Κατάσταση Επιταγών 26.06.2026.xlsx';
import bot_img from '../../../assets/icons/Final_Chatobot_RGB.SVG';
import { ReactComponent as SubmitLanding } from '../../../assets/icons/SubmitLanding.svg';
import { ReactComponent as SupplierIcon } from '../../../assets/icons/supplierIcon.svg';
import { ReactComponent as ArrowRight } from '../../../assets/icons/arrow-right.svg';
import { TableCell } from '@mui/material';
import HeaderLanding from './staticsHeader';
import Footer from './staticFooter';
import { useNavigate } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import Υπεύθυνη_Δήλωση_Νόμιμου_Εκπροσώπου_ΔΙΚ1 from '../../../assets/documents/Υπεύθυνη Δήλωση Νόμιμου Εκπροσώπου_ΔΙΚ1.docx';
import GuideForProperCompletionOfSupportingDocuments from '../../../assets/documents/Οδηγός ορθής συμπλήρωσης παραστατικών.pdf';
import CommonMistakesInSupportingDocuments from '../../../assets/documents/Συνήθη λάθη παραστατικών.pdf';
import PlatformCorrectionSteps from '../../../assets/documents/Βήματα διόρθωσης πλατφόρμας.pdf';
import simorfwsis from '../../../assets/documents/Υπεύθυνη Δήλωση Συμμόρφωσης.docx';
import Συχνές_Ερωτήσεις_v2 from '../../../assets/documents/Συχνές Ερωτήσεις_2ο τεύχος.pdf';
import Συχνές_Ερωτήσεις_v3 from '../../../assets/documents/Συχνές Ερωτήσεις_3ο τεύχος.pdf';
import ListaYpagoghsAntlies from '../../../assets/documents/2η Απόφαση Υπαγωγής_Αντλίες.pdf';
import DeuteriApofasiYpagogis from '../../../assets/documents/2η Απόφαση Έγκρισης πινάκων.pdf';
import DeuteriApofasiYpagogisMerged from '../../../assets/documents/2η Απόφαση Υπαγωγής_merged.pdf';
import DeuteriApofasiYpagogisThermosifones from '../../../assets/documents/2η Απόφαση Υπαγωγής_Ηλ. Θερμοσίφωνες.pdf';
import TritiApofasiYpagogisThermosifonesPdf from '../../../assets/documents/3η Απόφασης Υπαγωγής Θερμοσίφωνες.pdf';
import TritiApofasiYpagogisThermosifonesXlsx from '../../../assets/documents/3η Απόφασης Υπαγωγής Θερμοσίφωνες.xlsx';
import TritiApofasiYpagogisAntliesPdf from '../../../assets/documents/3η Απόφαση Υπαγωγής Αντλίες.pdf';
import TritiApofasiYpagogisAntliesXlsx from '../../../assets/documents/3η Απόφαση Υπαγωγής Αντλίες.xlsx';
import TritiApofasiPinakonPdf from '../../../assets/documents/3η Απόφαση Πινάκων (merged).pdf';
import ProtosPinakasOristikisAporripsisPdf from '../../../assets/documents/1ος Πίνακας Οριστικής Απόρριψης.pdf';
import Guide3 from '../../../assets/documents/3η Τροποποίηση Οδηγού.pdf';
import TetartosPinakasEgkrisis from '../../../assets/documents/4ος Πίνακας Έγκρισης.pdf';
import DeuterosPinakasOristikisAporripsis from '../../../assets/documents/2ος Πιν. Οριστικής Απόρριψης.pdf';
import DeuterosPinakasProsorinisAporripsis from '../../../assets/documents/2ος Πιν. Προσ. Απόρριψης.pdf';
import TetartiEgkrisiPinakwnMerged from '../../../assets/documents/4η Έγκριση Πινάκων_merged.pdf';

const { Content } = Layout;
const { Panel } = Collapse;
// const { Option } = Select;

const StaticPage1 = () => {
  const data = [
    {
      key: '1',
      column1: 'A',
      column2: 'Κτίριο (εφόσον τοποθετηθεί BEP στο κτίριο)',
      column3: '200 €',
    },
    {
      key: '2',
      column1: 'A',
      column2: 'Όροφος (εφόσον τοποθετηθεί FB στον όροφο)',
      column3: '140 €',
    },
    {
      key: '3',
      column1: 'Β',
      column2: 'Κτίριο',
      column3: '60 €',
    },
    {
      key: '4',
      column1: 'Γ',
      column2: 'Κτίριο',
      column3: '60 €',
    },
    {
      key: '5',
      column1: 'Δ',
      column2: 'Κτίριο',
      column3: '60 €',
    },
    {
      key: '6',
      column1: 'Ε',
      column2: 'Κτίριο',
      column3: '60 €',
    },
  ];

  const news = [
    {
      category: 'Νέα & Ανακοινώσεις',
      news: [
        {
          label:
            '«Αλλάζω Σύστημα Θέρμανσης και Θερμοσίφωνα»: Στη δημοσιότητα ο Οδηγός του προγράμματος',
          date: '03/01/2025',
          link: 'https://ypen.gov.gr/allazo-systima-thermansis-kai-thermosifona-sti-dimosiotita-o-odigos-tou-programmatos/',
        },
        {
          label:
            'Ανοίγει σήμερα για υποβολή αιτήσεων το πρόγραμμα «Αλλάζω Σύστημα Θέρμανσης και Θερμοσίφωνα»',
          date: '13/01/2025',
          link: 'https://ypen.gov.gr/anoigei-simera-gia-ypovoli-aitiseon-to-programma-allazo-systima-thermansis-kai-thermosifona/',
        },
        {
          label: 'Προγράμματα ενεργειακής αναβάθμισης – Χρήσιμες πληροφορίες ',
          date: '15/01/2025',
          link: 'https://ypen.gov.gr/programmata-energeiakis-anavathmisis-chrisimes-plirofories-ypourgeiou-perivallontos-kai-energeias/',
        },
        {
          label:
            'Εκδήλωση Υπουργείου Περιβάλλοντος και Ενέργειας για επτά προγράμματα ενεργειακής αναβάθμισης',
          date: '27/01/2025',
          link: 'https://ypen.gov.gr/ekdilosi-ypourgeiou-perivallontos-kai-energeias-gia-epta-programmata-energeiakis-anavathmisis/',
        },
        {
          label:
            'Παράταση υποβολής αιτήσεων σε επτά προγράμματα ενεργειακής αναβάθμισης',
          date: '18/03/2025',
          link: 'https://ypen.gov.gr/paratasi-ypovolis-aitiseon-se-epta-programmata-energeiakis-anavathmisis/',
        },
        {
          label:
            'Παράταση υποβολής αιτήσεων στο πρόγραμμα «Αλλάζω Σύστημα Θέρμανσης και Θερμοσίφωνα»',
          date: '30/04/2025',
          link: 'https://ypen.gov.gr/paratasi-ypovolis-aitiseon-sto-programma-allazo-systima-thermansis-kai-thermosifona/',
        },
        {
          label:
            'Η καταληκτική ημερομηνία εξαργύρωσης επιταγών του προγράμματος, είναι η 30η Απριλίου 2026.',
          date: '01/07/2025',
        },
        {
          label:
            'Υποβολή Αιτήσεων Συμμετοχής Προμηθευτών στο Πρόγραμμα «Αλλάζω Σύστημα Θέρμανσης και Θερμοσίφωνα»',
          date: '15/09/2025',
          link: 'https://ypen.gov.gr/ypovoli-aitiseon-symmetochis-promithefton-sto-programma-allazo-systima-thermansis-kai-thermosifona/',
        },
        {
          label:
            'Το Υπουργείο Περιβάλλοντος και Ενέργειας ανακοινώνει παρατάσεις σε ενεργειακά προγράμματα, ενταγμένα στο Ταμείο Ανάκαμψης και Ανθεκτικότητας',
          date: '19/09/2025',
          link: 'https://ypen.gov.gr/to-ypourgeio-perivallontos-kai-energeias-anakoinonei-parataseis-se-energeiaka-programmata-entagmena-sto-tameio-anakampsis-kai-anthektikotitas/',
        },
        {
          label:
            'Με σημαντικά αυξημένο προϋπολογισμό ξεκινά η υλοποίηση του προγράμματος «Αλλάζω Σύστημα Θέρμανσης και Θερμοσίφωνα» - Υπουργείο Περιβάλλοντος και Ενέργειας',
          date: '03/11/2025',
          link: 'https://ypen.gov.gr/me-simantika-afximeno-proypologismo-xekina-i-ylopoiisi-tou-programmatos-allazo-systima-thermansis-kai-thermosifona/',
        },
        {
          label:
            'Περισσότερα από 100.000 νοικοκυριά εντάσσονται στο Πρόγραμμα «Αλλάζω Σύστημα Θέρμανσης και Θερμοσίφωνα - Υπουργείο Περιβάλλοντος και Ενέργειας',
          date: '11/11/2025',
          link: 'https://ypen.gov.gr/perissotera-apo-100-000-noikokyria-entassontai-sto-programma-allazo-systima-thermansis-kai-thermosifona/',
        },
        {
          label:
            'Παρατάσεις στις προθεσμίες ολοκλήρωσης ενεργειακών προγραμμάτων του Ταμείου Ανάκαμψης και Ανθεκτικότητας - Υπουργείο Περιβάλλοντος και Ενέργειας',
          date: '13/03/2026',
          link: 'https://ypen.gov.gr/parataseis-stis-prothesmies-oloklirosis-energeiakon-programmaton-tou-tameiou-anakampsis-kai-anthektikotitas/',
        },
        {
          label:
            'Επιπλέον 6.000 νοικοκυριά εντάσσονται στο «Αλλάζω Σύστημα Θέρμανσης και Θερμοσίφωνα - Υπουργείο Περιβάλλοντος και Ενέργειας',
          date: '12/06/2026',
          link: 'https://ypen.gov.gr/epipleon-6-000-noikokyria-entassontai-sto-allazo-systima-thermansis-kai-thermosifona/',
        },
        {
          label:
            'Ξεκινούν σήμερα οι Πληρωμές του Προγράμματος «Αλλάζω Σύστημα Θέρμανσης και Θερμοσίφωνα» - Υπουργείο Περιβάλλοντος και Ενέργειας',
          date: '30/07/2026',
          link: 'https://ypen.gov.gr/xekinoun-simera-oi-pliromes-tou-programmatos-allazo-systima-thermansis-kai-thermosifona/',
        },
        {
          label:
            'Πρόγραμμα «Αλλάζω Σύστημα Θέρμανσης και Θερμοσίφωνα»: 17 εκατ. ευρώ σε 1.298 προμηθευτές - Υπουργείο Περιβάλλοντος και Ενέργειας',
          date: '09/09/2026',
          link: 'https://ypen.gov.gr/programma-allazo-systima-thermansis-kai-thermosifona-17-ekat-evro-se-1-298-promitheftes/',
        },

        {
          label:
            '36,4 εκατ. ευρώ σε 3.677 προμηθευτές και εγκαταστάτες για το «Αλλάζω Σύστημα Θέρμανσης και Θερμοσίφωνα» - Υπουργείο Περιβάλλοντος και Ενέργειας',
          date: '27/10/2026',
          link: 'https://ypen.gov.gr/364-ekat-evro-se-3-677-promitheftes-kai-egkatastates-gia-to-allazo-systima-thermansis-kai-thermosifona/',
        },
      ],
    },
  ];

  const documents = [
    {
      category: 'Αποτελέσματα Προγράμματος',
      documents: [
        {
          label: '1η Απόφαση Υπαγωγής',
          // date: '16/12/2022',
          link: FirstAdmissionDecision,
        },
        {
          label: '1ος Προσωρινός Πίνακας Προς Απόρριψη',
          // date: '23/02/2023',
          link: FirstProvisionaTableRejected,
        },
        {
          label: 'Απόφαση Έγκρισης Πινάκων',
          // date: '23/02/2023',
          link: DecisionApprovalTables,
        },
        {
          label: '2η Απόφαση Υπαγωγής Αντλίες',
          link: ListaYpagoghsAntlies,
        },
        {
          label: '2η Απόφαση Έγκρισης πινάκων',
          link: DeuteriApofasiYpagogis,
        },
        {
          label: '2η Απόφαση Έγκρισης πινάκων (merged)',
          link: DeuteriApofasiYpagogisMerged,
        },
        {
          label: '2η Απόφαση Υπαγωγής Θερμοσίφωνες',
          link: DeuteriApofasiYpagogisThermosifones,
        },
       {
          label: '3η Απόφαση Υπαγωγής Θερμοσίφωνες',
          link: TritiApofasiYpagogisThermosifonesPdf,
        },
        {
          label: '3η Απόφαση Υπαγωγής Θερμοσίφωνες (Excel)',
          link: TritiApofasiYpagogisThermosifonesXlsx,
        },
        {
          label: '3η Απόφαση Υπαγωγής Αντλίες',
          link: TritiApofasiYpagogisAntliesPdf,
        },
        {
          label: '3η Απόφαση Υπαγωγής Αντλίες (Excel)',
          link: TritiApofasiYpagogisAntliesXlsx,
        },
        {
          label: '3η Απόφαση Πινάκων (merged)',
          link: TritiApofasiPinakonPdf,
        },
        {
          label: '1ος Πίνακας Οριστικής Απόρριψης',
          link: ProtosPinakasOristikisAporripsisPdf,
        },
        {
          label: '2ος Πίνακας Οριστικής Απόρριψης',
          link: DeuterosPinakasOristikisAporripsis,
        },
        {
          label: '2ος Πίνακας Προσωρινής Απόρριψης',
          link: DeuterosPinakasProsorinisAporripsis,
        },
        {
          label: '4ος Πίνακας Έγκρισης',
          link: TetartosPinakasEgkrisis,
        },
        {
          label: '4η Έγκριση Πινάκων (merged)',
          link: TetartiEgkrisiPinakwnMerged,
        },
      ],
    },
    {
      category: 'Οδηγός Προγράμματος',
      documents: [
        {
          label: 'Οδηγός Προγράμματος',
          date: '13/01/2025',
          link: Guide,
        },
        {
          label: '1η Τροποποίηση Οδηγού',
          date: '05/02/2025',
          link: Guide1,
        },
        {
          label: '2η Τροποποίηση Οδηγού',
          date: '05/11/2025',
          link: Guide2,
        },
        {
          label: '3η Τροποποίηση Οδηγού',
          date: '19/03/2026',
          link: Guide3,
        },
      ],
    },

    {
      category: 'Έγγραφα Προμηθευτών',
      documents: [
        {
          label: 'Βεβαίωση Εγκατάστασης',
          // date: "...",
          link: GoodWork,
        },
        {
          label: 'Υπεύθυνη Δήλωση Νόμιμου Εκπροσώπου ΔΙΚ1',
          // date: "...",
          link: Υπεύθυνη_Δήλωση_Νόμιμου_Εκπροσώπου_ΔΙΚ1,
        },
        {
          label: 'Υπεύθυνη Δήλωση Συμμόρφωσης',
          // date: "...",
          link: simorfwsis,
        },
        {
          label: 'User Manual Προμηθευτών',
          // date: "...",
          link: UserManualSupplier,
        },
        {
          label: 'User Manual Δεσμευσης και Εξαργύρωσης voucher',
          // date: "...",
          link: UserManualReserveRedeem,
        },
        {
          label:
            'Εκπαιδευτικό βίντεο για τη διαδικασία δέσμευσης και εξαργύρωσης των επιταγών',
          link: 'https://youtu.be/dNMWwa3dbKE?si=ZCSTgGpYdMyMuIUG',
        },
        {
          label:
            'Οδηγός Ορθής Συμπλήρωσης Παραστατικών',
            // date: "...",
          link: GuideForProperCompletionOfSupportingDocuments,
        },
        {
          label:
            'Αρχείο ενημέρωσης προμηθευτών για συνήθη λάθη παραστατικών και τρόποι διόρθωσης σε ήδη εκδοθέντα παραστατικά',
            // date: "...",
          link: CommonMistakesInSupportingDocuments,
        },
        {
          label:
            'Βήματα διόρθωσης των αναρτημένων παραστατικών ή την αλλαγή πιστωτικού ιδρύματος ή/και IBAN',
            // date: "...",
          link: PlatformCorrectionSteps,
        },
      ],
    },
    {
      category: 'Έγγραφα Ωφελούμενων',
      documents: [
        {
          label: 'Υπόδειγμα Υπεύθυνης Δήλωσης Συναίνεσης Ιδιοκτήτη',
          // date: "",
          link: RespDeclarOwner,
        },
        {
          label: 'Πρότυπο ΥΔ De Minimis2023',
          // date: "",
          link: DeMinimins,
        },
        {
          label: 'Οδηγός συμπλήρωσης Πρότυπο ΥΔ De minimis',
          // date: "",
          link: DeMiniminsGuide,
        },
        {
          label: 'User Manual Ωφελούμενων',
          // date: "",
          link: UserManualBeneficiary,
        },
      ],
    },
    {
      category: 'Διάφορα',
      documents: [
        {
          label: 'Συχνές Ερωτήσεις',
          // date: '10/06/2022',
          link: FAQ,
        },
        {
          label: 'Οδηγίες Επικοινωνίας',
          //date: '',
          link: CommunicationGuide,
        },
        {
          label: 'Συχνές Ερωτήσεις v2',
          //date: '22/03/2023',
          link: Συχνές_Ερωτήσεις_v2,
        },
        {
          label: 'Συχνές Ερωτήσεις v3',
          //date: '22/03/2023',
          link: Συχνές_Ερωτήσεις_v3,
        },
        // {
        //   label: 'Διαδικασία και Ροή Χρήσης Επιταγών',
        //   link: VoucherUsageFlow,
        // },
        {
          label: 'Γεωγραφική Κατανομή Προμηθευτών & Κατάσταση Επιταγών',
          link: GeographicalDistributionVoucherStatus,
        },
        // {
        //   label: '2η Απόφαση Ένταξης Μητρώου Εγκαταστατών',
        //   date: '28/04/2023',
        //   link: Guide2nd,
        // },
      ],
    },
  ];

  const columnsA = [
    {
      title: '',
      dataIndex: 'header1',
      key: 'header1',
      width: 100,
      fixed: 'left',
    },
    {
      title: `Κατηγορία A`,
      children: [
        {
          title: 'Επιταγή προϊόντος',
          children: [
            {
              title: 'Εισοδηματικό Κριτήριο 1',
              dataIndex: 'col1',
              key: 'col1',
              width: 150,
            },
            {
              title: 'Εισοδηματικό Κριτήριο 2',
              dataIndex: 'col2',
              key: 'col2',
              width: 150,
            },
          ],
        },
        {
          title: 'Επιταγή υπηρεσιών',
          children: [
            {
              title: 'Εισοδηματικό Κριτήριο 1',
              dataIndex: 'col3',
              key: 'col3',
              width: 150,
            },
            {
              title: 'Εισοδηματικό Κριτήριο 2',
              dataIndex: 'col4',
              key: 'col4',
              width: 150,
            },
          ],
        },
      ],
    },
  ];

  const columnsB = [
    {
      title: '',
      dataIndex: 'header1',
      key: 'header1',
      width: 100,
      fixed: 'left',
    },
    {
      title: `Κατηγορία B`,
      children: [
        {
          title: 'Χωρίς Εισοδηματικά Κριτήρια',
          children: [
            {
              title: 'Επιταγή προϊόντος',
              dataIndex: 'col1',
              key: 'col1',
              width: 300,
            },
            {
              title: 'Επιταγή υπηρεσιών',
              dataIndex: 'col2',
              key: 'col2',
              width: 300,
            },
          ],
        },
      ],
    },
  ];

  const dataA = [
    {
      key: '1',
      header1: 'Ποσοστό ενίσχυσης (%)',
      col1: '60%',
      col2: '50%',
      col3: '60%',
      col4: '50%',
    },
    {
      key: '2',
      header1: 'Μέγιστη ονομαστική αξία επιταγών (€)',
      col1: '840',
      col2: '600',
      col3: '180',
      col4: '100',
    },
  ];

  const dataB = [
    {
      key: '1',
      header1: 'Ποσοστό ενίσχυσης (%)',
      col1: '50%',
      col2: '50%',
    },
    {
      key: '2',
      header1: 'Μέγιστη ονομαστική αξία επιταγών (€)',
      col1: '5000',
      col2: '1000',
    },
  ];

  const [generalInfo, setGeneralInfo] = useState(false);
  const [docsTab, setDocsTab] = useState(false);
  const [newsTab, setNewsTab] = useState(false);
  const [activeKey, setActiveKey] = useState();
  const [showBot, setShowBot] = useState(false);
  const [minimizeBot, setMinimizeBot] = useState(false);

  const handleMinimize = () => {
    setShowBot(false);
    setMinimizeBot(true);
  };

  const handleOpen = () => {
    setShowBot(true);
    setMinimizeBot(false);
  };

  return (
    <Layout id="landing-page">
      <HeaderLanding
        setShowBot={setShowBot}
        showBot={showBot}
        className="header-landing"
      />
      <Content>
        <div className="sub-header-image">
          <div className="hero-space">
            <div className="hero-space-body">
              <div className="left-hero-space">
                <div className="hero-text-space">
                  <span className="left-hero-text">
                    Έξυπνη Θέρμανση, Καθαρή Ενέργεια!
                  </span>
                </div>
                <div className="title-display-space">
                  <div id="hero-texts">
                    <div className="header-text-2">
                      <span>Αλλάζω Σύστημα Θέρμανσης & Θερμοσίφωνα</span>
                    </div>
                    <div className="title-text-1">
                      <FirstIcon />
                      <div className="title-text">
                        <span>
                          Αποκτήστε επιχορήγηση για αντικατάσταση ενεργοβόρων
                          ηλεκτρικών θερμοσίφωνων, με νέους σύγχρονης
                          τεχνολογίας ηλιακούς θερμοσίφωνες ή/και με σύστημα
                          αντλίας θερμότητας.
                        </span>
                      </div>
                    </div>
                    <div className="title-text-1">
                      <SecondIcon />
                      <span className="title-text">
                        Επιλέξτε τον επιθυμητό Εξοπλισμό από την εγκεκριμένη
                        <a
                          className="title-text"
                          href={`${process.env.REACT_APP_URL_DOMAIN}/${process.env.REACT_APP_BACKEND_FLOWABLE_CONTEXT_PATH}/api/export/equipment`}
                          download
                        >
                          Λίστα Εξοπλισμού.
                        </a>
                      </span>
                    </div>
                    <div className="title-text-1">
                      <SecondIcon />
                      <span className="title-text">
                        Βρείτε την
                        <a
                          className="title-text"
                          href={`${process.env.REACT_APP_URL_DOMAIN}/${process.env.REACT_APP_BACKEND_FLOWABLE_CONTEXT_PATH}/api/export/suppliers`}
                          download
                        >
                          Λίστα Προμηθευτών.
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="right-hero-space">
                <LandingAntliesIcon className="phone-icon-wrapper" />
              </div>
            </div>
            <div className="hero-footer">
              <div id="hero-text">
                To Πρόγραμμα «ΑΛΛΑΖΩ ΣΥΣΤΗΜΑ ΘΕΡΜΑΝΣΗΣ ΚΑΙ ΘΕΡΜΟΣΙΦΩΝΑ» 
                υλοποιείται στο πλαίσιο του Εθνικού Σχεδίου Ανάκαμψης και
                Ανθεκτικότητας Ελλάδα 2.0 με τη χρηματοδότηση της Ευρωπαϊκής
                Ένωσης - NextGenerationEU
              </div>
            </div>
            <div className="footer-links">
              <span className="complaints-label">Για καταγγελίες ΤΑΑ:</span>
              <a
                href="https://greece20.gov.gr/kataggelies/"
                target="_blank"
                rel="noreferrer"
              >
                Καταγγελίες για έργα – Ελλάδα 2.0
              </a>
            </div>
          </div>
        </div>
        <div className="sub-header-container">
          <div className="sub-header mb-3">
            <div className="deadline-extension-banner">
              <div className="deadline-extension-text">
                <p>
                  Σας ενημερώνουμε ότι η εξέταση της ένστασής σας έχει
                  ολοκληρωθεί και μπορείτε να βρείτε τα αποτελέσματα στην
                  πλατφόρμα του Προγράμματος.
                </p>
                <p>Παρακαλούμε όπως ακολουθήσετε τα παρακάτω βήματα:</p>
                <ol>
                  <li>
                    Εισέλθετε στη διεύθυνση:{' '}
                    <a
                      href="https://allazosistimathermansis-thermosifona.gov.gr/go-beyond/login"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="deadline-extension-email"
                    >
                      https://allazosistimathermansis-thermosifona.gov.gr/go-beyond/login
                    </a>
                  </li>
                  <li>
                    Συνδεθείτε χρησιμοποιώντας τα προσωπικά σας διαπιστευτήρια{' '}
                    <strong>Taxisnet</strong>.
                  </li>
                  <li>
                    Επιλέξτε την ένδειξη <strong>«Προβολή»</strong> από το
                    μενού, στις τρεις τελείες δεξιά στη γραμμή της αίτησής σας.
                  </li>
                  <li>
                    Επιλέξτε την καρτέλα <strong>2 «Στοιχεία Αίτησης»</strong>{' '}
                    και στη συνέχεια το εικονίδιο <strong>«Αίτηση»</strong>,
                    στο επάνω δεξιά σημείο της σελίδας.
                  </li>
                  <li>
                    Τέλος, μεταβείτε στην καρτέλα{' '}
                    <strong>6 «Εξέταση Ένστασης»</strong>, όπου εμφανίζεται το
                    αποτέλεσμα της εξέτασης της ένστασής σας.
                  </li>
                </ol>
                <p>
                  Για τη διευκόλυνσή σας, παρατίθεται συνοπτική επεξήγηση των
                  πιθανών αποτελεσμάτων:
                </p>
                <ul>
                  <li>
                    <strong>Αποδοχή ένστασης</strong>
                    <br />
                    Η ένστασή σας έγινε πλήρως αποδεκτή.
                  </li>
                  <li>
                    <strong>Απόρριψη ένστασης</strong>
                    <br />
                    Η ένστασή σας δεν έγινε αποδεκτή.
                  </li>
                </ul>
                <p>
                  Αναφορικά με την οριστική αξιολόγηση της αίτησής σας, θα
                  εκδοθεί νέα απόφαση η οποία θα αναρτηθεί στην επίσημη
                  ιστοσελίδα του προγράμματος και θα ενημερωθείτε με νεότερο
                  email.
                </p>
                <p>
                  Για οποιαδήποτε περαιτέρω ενημέρωση ή διευκρίνιση, παρακαλούμε
                  να απευθυνθείτε στο Help Desk.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="sub-header-container">
          <div className="sub-header mb-3">
            <div className="deadline-extension-banner">
              <p className="deadline-extension-text">
                <strong>
                  Καταληκτική ημερομηνία δέσμευσης και εξαργύρωσης των επιταγών των εγκεκριμένων ωφελούμενων:  
                  <ul>
                     <li>
                      Έως και 25/06/2026 για την εξαργύρωση της Επιταγής Προϊόντος (εξοπλισμός) & Επιταγής Υπηρεσίας της 2ης (03/03/2026) και 3ης  (23/04/2026) απόφασης υπαγωγής
                    </li>
                    <li>
                      Έως και 25/06/2026 για την δέσμευση και εξαργύρωση της Επιταγής Προϊόντος (εξοπλισμός) & Επιταγής Υπηρεσίας της 4ης απόφασης υπαγωγής (11/06/2026)
                    </li>
                  </ul>
                </strong>
              </p>
            </div>
          </div>
        </div>

        <div className="sub-header-container">
          <div className="sub-header mb-3">
            <div className="deadline-extension-banner">
              <p className="deadline-extension-text">
                <strong>
                  Επί της απόφασης προσωρινής απόρριψης παρέχεται δικαίωμα υποβολής ένστασης μέσω της ψηφιακής πλατφόρμας του Προγράμματος, εντός αποκλειστικής προθεσμίας επτά (7) ημερολογιακών ημερών.
                </strong>
              </p>
            </div>
          </div>
        </div>

        <div className="sub-header-container">
          <div className="sub-header mb-3">
            <div className="deadline-extension-banner">
              <p className="deadline-extension-text">
                <strong>
                  Αναρτήθηκε το νέο, επικαιροποιημένο 3ο τεύχος Συχνών Ερωτήσεων & Απαντήσεων στα Έγγραφα του Προγράμματος.
                </strong>
              </p>
            </div>
          </div>
        </div>

        <div className="sub-header-container">
          <div className="sub-header mb-3">
            <div className="deadline-extension-banner">
              <p className="deadline-extension-text">
                <strong>
                  Νέο email αποκλειστικά για την εξυπηρέτηση προμηθευτών, <br />
                  <a
                    href="mailto:allazothermansi.thermosifona.suppliers@prv.ypeka.gr"
                    className="deadline-extension-email"
                  >
                    allazothermansi.thermosifona.suppliers@prv.ypeka.gr
                  </a>
                </strong>
              </p>
            </div>
          </div>
        </div>

        <div className="sub-header-container">
          <div className="sub-header mb-3">
            <div className="deadline-extension-banner">
              <p className="deadline-extension-text">
                <strong>
                  <ul>
                    <li>
                      Η δεσμευμένη Επιταγή Προϊόντος παραμένει σε κατάσταση
                      δέσμευσης έως 30 ημερολογιακές ημέρες, διάστημα εντός του
                      οποίου πρέπει να ολοκληρωθεί η διαδικασία πώλησης.
                    </li>
                    <li>
                      Η δεσμευμένη Επιταγή Υπηρεσιών έπεται της δεσμευμένης
                      Επιταγής Προϊόντος και παραμένει δεσμευμένη έως 60
                      ημερολογιακές ημέρες, εντός των οποίων πρέπει να
                      ολοκληρωθεί η διαδικασία εγκατάστασης.
                    </li>
                  </ul>
                </strong>
              </p>
            </div>
          </div>
        </div>

        <div className="sub-header-container">
          <div className="sub-header mb-3">
            <div className="deadline-extension-banner">
              <p className="deadline-extension-text">
                <strong>
                  Πατήστε τον{' '}
                  <a
                    href="https://youtu.be/dNMWwa3dbKE?si=ZCSTgGpYdMyMuIUG"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    σύνδεσμο
                  </a>{' '}
                  για να δείτε το εκπαιδευτικό βίντεο με τη διαδικασία δέσμευσης
                  και εξαργύρωσης των επιταγών στην πλατφόρμα, το οποίο είναι
                  αναρτημένο και στα Έγγραφα Προμηθευτών του Προγράμματος.
                </strong>
              </p>
            </div>
          </div>
        </div>

        <div className="sub-header-container">
          <div className="sub-header mb-3">
            <div className="deadline-extension-banner">
              <p className="deadline-extension-text">
                <strong>
                  Όλοι οι ενδιαφερόμενοι και οι προμηθευτές οφείλουν να τηρούν
                  τους όρους, τις προϋποθέσεις και τις διαδικασίες του
                  Προγράμματος. Παρακαλούμε να ενημερώνεστε προσεκτικά και να
                  ενεργείτε σύμφωνα με τις ισχύουσες οδηγίες.
                </strong>
              </p>
            </div>
          </div>
        </div>
        <div className="badges-container">
          <div className="badges">
            <div className="badges-content">
              <div className="badges-content-header">
                <SubmitLanding className="badge-icon" />
                <h2 className="badges-title">Πλατφόρμα Προγράμματος</h2>
              </div>
              <div className="badges-text-container">
                <p
                  className="badges-text"
                  style={{ color: '#46616B', fontSize: '1.375rem' }}
                >
                  <p>
                    Αν είσαι ωφελούμενος, δες την αίτησή σου (είσοδος με
                    κωδικούς TAXISnet)
                  </p>
                  {/* <br /> */}
                  <p>
                    Αν είσαι προμηθευτής, κάνε δέσμευση και αίτημα εξαργύρωσης
                    (είσοδος ως διαχειριστής)
                  </p>
                </p>
                {process.env.REACT_APP_LANDING_LOGIN_TO_PLATFORM === 'true' && (
                  <a
                    href={loginUrl2}
                    className="badges-button"
                    style={{
                      marginTop: '1rem',
                      borderRadius: '23px',
                      fontFamily: 'Comfortaa',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '0.5rem',
                    }}
                  >
                    Είσοδος στην πλατφόρμα <ArrowRight />
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="badges-container">
          <div className="badges">
            <div className="badges-content">
              <div className="badges-content-header">
                <SupplierIcon className="badge-icon" />
                <h2 className="badges-title">Εγγραφή στο μητρώο προμηθευτών</h2>
              </div>
              <div className="badges-text-container">
                {/* <p
                  className="badges-text"
                  style={{ color: '#46616B', fontSize: '1.375rem' }}
                >
                  Κάνε εγγραφή στο Μητρώο Προμηθευτών.
                </p> */}
                {process.env.REACT_APP_LOGIN_TO_SUPPLIER_PLATFORM ===
                  'true' && (
                  <a
                    href={loginUrlSuppliers}
                    className="badges-button"
                    style={{
                      marginTop: '1rem',
                      borderRadius: '23px',
                      fontFamily: 'Comfortaa',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '0.5rem',
                    }}
                  >
                    Πλατφόρμα Προμηθευτών <ArrowRight />
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="main-content">
          <div className="collapse-header">
            <Button
              className={newsTab ? 'active-page' : ''}
              id="staticButtons"
              onClick={() => {
                setNewsTab(!newsTab);
                // setGeneralInfo(true);
                setDocsTab(false);
              }}
            >
              <span className="badge-span">ΝΕΑ ΚΑΙ ΑΝΑΚΟΙΝΩΣΕΙΣ</span>
            </Button>
            <Button
              className={docsTab ? 'active-page' : ''}
              id="staticButtons"
              onClick={() => {
                setNewsTab(false);
                // setGeneralInfo(false);
                setDocsTab(!docsTab);
              }}
            >
              <span className="badge-span">ΕΓΓΡΑΦΑ ΠΡΟΓΡΑΜΜΑΤΟΣ</span>
            </Button>
          </div>
          {newsTab &&
            !isEmpty(news) &&
            !news?.every(category => isEmpty(category?.news)) && (
              <div className="documents-content">
                <h1 className="documents-header">Νέα & Ανακοινώσεις</h1>
                <div className="documents-items">
                  {news?.map(item => (
                    <div className="docs">
                      {/* <h2 className="documents-category">{item.category}</h2> */}
                      <div className="documents-info">
                        {item.news.reverse()?.map(item => (
                          <>
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={item.link}
                            >
                              {item.label}
                            </a>
                            <p>{item.date}</p>
                          </>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          {docsTab &&
            !isEmpty(documents) &&
            !documents?.every(category => isEmpty(category?.documents)) && (
              <div className="documents-content">
                <h1 className="documents-header">Έγγραφα Προγράμματος</h1>
                <div className="documents-items">
                  <div className="documents-main">
                    <div className="documents-row">
                      {documents
                        .filter(
                          item =>
                            item.category === 'Αποτελέσματα Προγράμματος' ||
                            item.category === 'Οδηγός Προγράμματος'
                        )
                        .map(item => (
                          <div className="docs" key={item.category}>
                            <h2 className="documents-category">
                              {item.category}
                            </h2>
                            <div className="documents-info">
                              {item.documents?.map(doc => (
                                <>
                                  <a
                                    target="_blank"
                                    rel="noreferrer"
                                    href={doc.link}
                                  >
                                    {doc.label}
                                  </a>
                                  <p>{doc.date}</p>
                                </>
                              ))}
                            </div>
                          </div>
                        ))}
                    </div>
                    <div className="documents-row">
                      {documents
                        .filter(
                          item =>
                            item.category === 'Έγγραφα Ωφελούμενων' ||
                            item.category === 'Έγγραφα Προμηθευτών'
                        )
                        .map(item => (
                          <div className="docs" key={item.category}>
                            <h2 className="documents-category">
                              {item.category}
                            </h2>
                            <div className="documents-info">
                              {item.documents?.map(doc => (
                                <>
                                  <a
                                    target="_blank"
                                    rel="noreferrer"
                                    href={doc.link}
                                  >
                                    {doc.label}
                                  </a>
                                  <p>{doc.date}</p>
                                </>
                              ))}
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                  <div className="documents-right">
                    {documents
                      .filter(item => item.category === 'Διάφορα')
                      .map(item => (
                        <div className="docs" key={item.category}>
                          <h2 className="documents-category">
                            {item.category}
                          </h2>
                          <div className="documents-info">
                            {item.documents?.map(doc => (
                              <>
                                <a
                                  target="_blank"
                                  rel="noreferrer"
                                  href={doc.link}
                                >
                                  {doc.label}
                                </a>
                                <p>{doc.date}</p>
                              </>
                            ))}
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            )}
          {
            <div id="landing-info">
              <Collapse
                key="1"
                className="main-content__collapse"
                expandIcon={({ isActive }) =>
                  isActive ? (
                    <Minus style={{ marginRight: '12px' }} />
                  ) : (
                    <Plus style={{ marginRight: '12px' }} />
                  )
                }
                expandIconPosition={'right'}
                onChange={e =>
                  activeKey === '1' ? setActiveKey('') : setActiveKey('1')
                }
                activeKey={activeKey}
              >
                <Panel
                  header={
                    <text className="panel-header-text">
                      Σκοπός και Αντικείμενο
                    </text>
                  }
                  key="1"
                >
                  <div>
                    <b style={{ fontSize: '1.5rem' }}>Σκοπός και Αντικείμενο</b>
                    <br></br>
                    <br></br>
                    <p>
                      Το Πρόγραμμα «Αλλάζω Σύστημα Θέρμανσης και Θερμοσίφωνα»
                      επιχορηγεί νοικοκυριά για την αντικατάσταση ενεργοβόρων
                      ηλεκτρικών θερμοσίφωνων, με νέους σύγχρονης τεχνολογίας
                      ηλιακούς θερμοσίφωνες ή/και με σύστημα αντλίας θερμότητας.
                      Το πρόγραμμα περιλαμβάνει:
                    </p>
                    <p>
                      <ul>
                        <li>
                          Την επιδότηση αγοράς νέου ηλιακού́ θερμοσίφωνα
                          σύγχρονης τεχνολογίας (Επιλέξιμος Εξοπλισμός
                          Κατηγορίας Α).
                        </li>
                        <li>
                          Την επιδότηση αγοράς νέου συστήματος αντλίας
                          θερμότητας θέρμανσης (συμπεριλαμβάνεται η εξωτερική
                          μονάδα, fan coil, σωληνώσεις) (Επιλέξιμος Εξοπλισμός
                          Κατηγορίας Β).
                        </li>
                        <li>
                          Την επιδότηση της δαπάνης για την εκτέλεση αναγκαίων
                          συμπληρωματικών εργασιών τοποθέτησης επιλέξιμου
                          εξοπλισμού (π.χ. κόστος μεταφοράς, κόστος τοποθέτησης,
                          αναλώσιμα, εξαρτήματα, smart system (χρονοδιακόπτης)
                          κλπ.) (Επιλέξιμη Δαπάνη των Κατηγοριών Α και Β).{' '}
                        </li>
                      </ul>
                    </p>
                    <p>
                      Βασικοί στόχοι του Προγράμματος είναι η αύξηση των
                      ανανεώσιμων πηγών ενέργειας (ΑΠΕ) και η εξοικονόμηση
                      οικονομικών πόρων από τη μείωση της κατανάλωσης ενέργειας.
                      Συγκεκριμένα, η χρήση ΑΠΕ για τη παραγωγή ζεστού νερού
                      χρήσης αναμένεται να μειώσει σημαντικά το μέσο ενεργειακό
                      κόστος της ελληνικής οικογένειας και παράλληλα η
                      χαμηλότερη ζήτηση ηλεκτρικής ενέργειας συνεπάγεται σε
                      μικρότερη παραγωγή από ορυκτά καύσιμα ή μη ανανεώσιμες
                      πηγές.
                    </p>
                    <p>
                      Ένας ακόμα βασικός στόχος του Προγράμματος είναι η μείωση
                      χρήσης συστημάτων θέρμανσης με βάση τα ορυκτά καύσιμα και
                      τη βιομάζα που επιβαρύνουν σημαντικά την ατμοσφαιρική
                      ρύπανση με αιωρούμενα σωματίδια. Μεγαλύτερο τμήμα του
                      προϋπολογισμού του Προγράμματος θα διατεθεί προς τους
                      ωφελούμενους στις Περιφέρειες Κεντρικής Μακεδονίας και
                      Ηπείρου όπου με βάση στοιχεία μετρήσεων ατμοσφαιρικής
                      ρύπανσης των τελευταίων πέντε (5) χρόνων, καταγράφεται
                      συχνή υπέρβαση των μέγιστων επιτρεπτών ορίων σωματιδιακής
                      ρύπανσης αρκετές φορές ετησίως σε σχέση με τις υπόλοιπες
                      Περιφέρειες της Ελλάδας.
                    </p>
                  </div>
                </Panel>
              </Collapse>

              <Collapse
                key="2"
                className="main-content__collapse"
                expandIcon={({ isActive }) =>
                  isActive ? (
                    <Minus style={{ marginRight: '12px' }} />
                  ) : (
                    <Plus style={{ marginRight: '12px' }} />
                  )
                }
                expandIconPosition={'right'}
                onChange={e =>
                  activeKey === '2' ? setActiveKey('') : setActiveKey('2')
                }
                activeKey={activeKey}
              >
                <Panel
                  header={
                    <text className="panel-header-text">
                      Δικαιούχοι του Προγράμματος
                    </text>
                  }
                  key="2"
                >
                  <div>
                    <b style={{ fontSize: '1.5rem' }}>
                      Δικαιούχοι του Προγράμματος
                    </b>
                    <br></br>
                    <br></br>
                    <p>
                      Δυνητικοί ωφελούμενοι του Προγράμματος είναι οικιακοί
                      καταναλωτές που επιθυμούν να τοποθετήσουν στην οικία τους
                      (ενοικιαζόμενη /δωρεάν παραχωρούμενη) ηλιακό θερμοσίφωνα
                      νέας τεχνολογίας ή/και νέου συστήματος αντλίας θερμότητας.
                    </p>
                    <p>
                      Στις ενοικιαζόμενες/δωρεάν παραχωρούμενες κατοικίες
                      εφαρμόζονται οι διατάξεις του Κανονισμού 2831/2023 της
                      Επιτροπής ΕΕ για τις ενισχύσεις ήσσονος σημασίας (de
                      minimis), όπου καθορίζονται τα όρια σώρευσης (300.000 €).
                      Από πλευράς ιδιοκτητών των ακινήτων, πριν τη χορήγηση της
                      ενίσχυσης, θα πρέπει να δηλωθεί υπεύθυνα η τήρηση όλων των
                      όρων που καθορίζονται στον Κανονισμό για ενισχύσεις
                      ήσσονος σημασίας 2831/2023 (de minimis) και για
                      οποιαδήποτε άλλη ενίσχυση ήσσονος σημασίας έχει ληφθεί
                      βάσει του εν λόγω Κανονισμού ή άλλων Κανονισμών για
                      ενισχύσεις ήσσονος σημασίας κατά τα τρία (3) τελευταία
                      έτη, σε συμμόρφωση με τα οριζόμενα στην παρ. 4 του άρθρου
                      6 του Κανονισμού. Υπόδειγμα της ανωτέρω δήλωσης
                      συμμόρφωσης με τον κανονισμό de minimis της οποίας
                      προστεθεί ως παράρτημα στον Οδηγό (Παράρτημα ΙV). Οι
                      αιτήσεις χρηματοδότησης υποβάλλονται από μεμονωμένα Φυσικά
                      Πρόσωπα τα οποία διαμένουν μόνιμα στην Ελλάδα. Προκειμένου
                      να υποβάλλει αίτηση ένα Φυσικό Πρόσωπο θα πρέπει να
                      συντρέχουν σωρευτικά οι κάτωθι προϋποθέσεις:
                    </p>
                    <p>
                      <ul>
                        <li>
                          Να διαθέτει υποχρεωτικά Αριθμό Φορολογικού Μητρώου,
                          καθώς και έγκυρους κωδικούς πρόσβασης στις
                          ηλεκτρονικές υπηρεσίες της ΑΑΔΕ, μέσω των οποίων
                          γίνεται η ταυτοποίηση των προσωπικών στοιχείων μέσω
                          ΟΠΣ.
                        </li>
                        <li>
                          Να έχει υποβάλει κατά το έτος αναφοράς (φορολογικό
                          έτος 2023) δήλωση φορολογίας εισοδήματος (Ε1), είτε ως
                          ΥΠΟΧΡΕΟΣ ατομικής ή κοινής δήλωσης, είτε εμμέσως ως
                          «ΣΥΖΥΓΟΣ/ΜΣΣ » σε περίπτωση κοινής δήλωσης. Η σχετική
                          δήλωση θα πρέπει να έχει εκκαθαριστεί.
                        </li>
                        <li>
                          Δεν είναι επιλέξιμοι ωφελούμενοι (Φυσικά Πρόσωπα που
                          υποβάλουν την αίτηση) οι οποίοι είχαν υποβάλει δήλωση
                          φορολογίας εισοδήματος κατά το έτος αναφοράς (2023) ως
                          κάτοικοι εξωτερικού.
                        </li>
                        <li>
                          Εξαρτώμενα μέλη που δεν υποβάλλουν αυτόνομα δήλωση
                          (δηλ. δεν είναι υπόχρεοι σε δική τους ατομική δήλωση)
                          δε δύνανται να υποβάλλουν αίτηση για τη συμμετοχή τους
                          στο Πρόγραμμα.
                        </li>
                      </ul>
                    </p>
                  </div>
                </Panel>
              </Collapse>

              <Collapse
                key="3"
                className="main-content__collapse"
                expandIcon={({ isActive }) =>
                  isActive ? (
                    <Minus style={{ marginRight: '12px' }} />
                  ) : (
                    <Plus style={{ marginRight: '12px' }} />
                  )
                }
                expandIconPosition={'right'}
                onChange={e =>
                  activeKey === '3' ? setActiveKey('') : setActiveKey('3')
                }
                activeKey={activeKey}
              >
                <Panel
                  header={
                    <text className="panel-header-text">Ποσό Ενίσχυσης</text>
                  }
                  key="3"
                >
                  <div>
                    <b style={{ fontSize: '1.5rem' }}>Ποσό Ενίσχυσης</b>
                    <br></br>
                    <br></br>
                    <p>Είναι οι παρακάτω πίνακες</p>
                    <p>
                      <Table
                        columns={columnsA}
                        dataSource={dataA}
                        bordered
                        pagination={false}
                        scroll={{ x: 800 }}
                      />
                    </p>
                    <p>
                      <Table
                        columns={columnsB}
                        dataSource={dataB}
                        bordered
                        pagination={false}
                        scroll={{ x: 800 }}
                      />
                    </p>
                  </div>
                </Panel>
              </Collapse>

              <Collapse
                key="4"
                className="main-content__collapse"
                expandIcon={({ isActive }) =>
                  isActive ? (
                    <Minus style={{ marginRight: '12px' }} />
                  ) : (
                    <Plus style={{ marginRight: '12px' }} />
                  )
                }
                expandIconPosition={'right'}
                onChange={e =>
                  activeKey === '4' ? setActiveKey('') : setActiveKey('4')
                }
                activeKey={activeKey}
              >
                <Panel
                  header={
                    <text className="panel-header-text">Χρονικά Ορόσημα</text>
                  }
                  key="4"
                >
                  <div>
                    <b style={{ fontSize: '1.5rem' }}>Χρονικά Ορόσημα</b>
                    <br></br>
                    <br></br>
                    <p>
                      Η έναρξη υποβολής Αιτήσεων χρηματοδότησης από δυνητικούς
                      ωφελούμενους θα ενεργοποιηθεί την 13-01-2025.
                    </p>
                    <p>
                      Η υποβολή των αιτήσεων θα πραγματοποιείται από 13-01-2025
                      έως 05-05-2025 κατόπιν ενημερωτικού δελτίου τύπου του
                      Υπουργείου Περιβάλλοντος και Ενέργειας.
                    </p>
                    <p>
                      Η χρήση επιταγών για αγορά επιλέξιμου εξοπλισμού του
                      Προγράμματος μπορεί να πραγματοποιηθεί από τους
                      ωφελούμενους μέχρι και ενενήντα (90) ημέρες από την έκδοση
                      των επιταγών.
                    </p>
                    <p>
                      Η χρήση των επιταγών για παροχή υπηρεσιών από τους
                      ωφελούμενους προϋποθέτει την δέσμευση των επιταγών αγοράς
                      επιλέξιμου εξοπλισμού, και πρέπει να πραγματοποιηθεί εντός
                      εκατόν είκοσι (120) ημερών από την έκδοση της Απόφασης
                      Υπαγωγής, και όχι αργότερα από τις 30-04-2026.
                    </p>
                    <p>
                      Η καταληκτική ημερομηνία εξαργύρωσης επιταγών του
                      προγράμματος, είναι η 30η Απριλίου 2026.
                    </p>
                  </div>
                </Panel>
              </Collapse>

              <Collapse
                key="5"
                className="main-content__collapse"
                expandIcon={({ isActive }) =>
                  isActive ? (
                    <Minus style={{ marginRight: '12px' }} />
                  ) : (
                    <Plus style={{ marginRight: '12px' }} />
                  )
                }
                expandIconPosition={'right'}
                onChange={e =>
                  activeKey === '5' ? setActiveKey('') : setActiveKey('5')
                }
                activeKey={activeKey}
              >
                <Panel
                  header={
                    <text className="panel-header-text">
                      Διαδικασία Υποβολής Αίτησης στο Πρόγραμμα
                    </text>
                  }
                  key="5"
                >
                  <div>
                    <b style={{ fontSize: '1.5rem' }}>
                      Διαδικασία Υποβολής Αίτησης στο Πρόγραμμα
                    </b>
                    <br></br>
                    <br></br>
                    <p>
                      Προκειμένου να εκδοθεί το Voucher, θα πρέπει να
                      ακολουθηθούν τα παρακάτω βήματα:
                    </p>
                    <p>
                      Ωφελούμενοι:
                      <ol>
                        <li>
                          Να κάνουν εισαγωγή στην πλατφόρμα και υποβολή αίτησης
                        </li>
                        <li>
                          Εφόσον εγκριθεί τελικώς η αίτηση και λάβουν το κουπόνι
                          στο <b>e-mail </b>
                          τους μπορούν να απευθυνθούν σε προμηθευτή ώστε να
                          διαλέξουν εξοπλισμό και υπηρεσίες.
                        </li>
                      </ol>
                    </p>
                    <p>
                      Προμηθευτές:
                      <ol>
                        <li>
                          Θα πρέπει να κάνουν την εγγραφή τους στο Μητρώο
                          Προμηθευτών και να δηλώσουν τον εξοπλισμό τους
                        </li>
                        <li>
                          Εφόσον η αίτηση εγκριθεί πλέον μπορούν να εισέλθουν
                          και στην πλατφόρμα του προγράμματος.
                        </li>
                      </ol>
                    </p>
                  </div>
                </Panel>
              </Collapse>
            </div>
          }
        </div>
      </Content>
      <Footer />
    </Layout>
  );
};

export default StaticPage1;
